import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { CommonStyles } from '../styles/Styles';
import { ButtonComponent } from './quizzing/ButtonComponent';
import Grid from '@material-ui/core/Grid';
import { Icon } from '@material-ui/core';
import { AppTheme } from '../styles/AppTheme';
import { dataItem } from '../data/data';
import { AppConfig } from '../AppConfig';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { UiHelper } from '../common/helpers/UiHelper';
import { MsgDialog } from '../components/MsgDialog';
import { CatHeader } from '../components/CatHeader';

export class Customize extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMsgDialog: false,
      optionals: [],
      baselines: [],
      mandatory: [],
      selectedTileIds: {},
      fetchState: ApiHelper.State.LOADING
    }
  }

  componentDidMount() {
    this.fetchItems()
  }

  onTileClicked = (item) => {
    if (this.props.inProcess) {
      return
    }
    if (!this.isValidAgeLimit()) {
      this.setState({
        showMsgDialog: true
      })
      return
    }
    const selectedTileIds = this.state.selectedTileIds
    if (item.id in selectedTileIds) {
      delete selectedTileIds[item.id]
    } else {
      selectedTileIds[item.id] = true
    }

    this.setState({
      selectedTileIds: selectedTileIds
    })
  }

  fetchItems = () => {
    ApiHelper.call(
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['/miscs/quiz-sections'], { quizId: AppConfig.quizId }) },
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        const baselines = []
        const optionals = []
        const mandatory = []
        let selectedTileIds = {}
        if (result && result.sections) {
          for (const item of result.sections) {
            if (item.baseline === 'YES' || item.baseline === 'BASELINE') {
              baselines.push(item)
              selectedTileIds[item.id] = true
            } else if (item.baseline === 'MANDATORY') {
              mandatory.push(item)
              selectedTileIds[item.id] = true
            } else {
              optionals.push(item)
            }
          }
        }

        if (this.props.responseByQuestionId.preferedQSections &&
          this.props.responseByQuestionId.preferedQSections.length > 0) {
          selectedTileIds = {}
          for (const item of this.props.responseByQuestionId.preferedQSections) {
            selectedTileIds[item] = true
          }
        } else {
          if (result && result.sections) {
            for (const item of result.sections) {
              selectedTileIds[item.id] = true
            }
          }
        }

        this.setState({
          optionals: optionals,
          baselines: baselines,
          mandatory: mandatory,
          selectedTileIds: selectedTileIds,
          fetchState: ApiHelper.State.READY
        })
      }.bind(this))
  }

  onFinish = () => {
    const ids = []
    for (const key in this.state.selectedTileIds) {
      ids.push(key)
    }
    this.props.handleState('preferedQSections', ids)
    this.props.nextStepper()
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  showSurveys = () => {
    if (this.state.baselines.length === 0 &&
      this.state.optionals.length === 0 &&
      this.state.mandatory.length === 0) {
      return (
        <p className={css(CommonStyles.stepperSubTitleContent)}>No surveys found.</p>
      )
    }
    return (
      <div className={css(CommonStyles.stepperInnerContent, CommonStyles.innerErrorContainer)}>
        {this.props.showConsentCompleteMsg &&
          <div className={css(Styles.consentCompleteMsgContainer)}>
            <p className={css(CommonStyles.stepperTitleContent, Styles.consentCompleteMsg)}>{Helper.getString('consentCompleteMsg1')}</p>
            <p className={css(CommonStyles.stepperTitleContent, Styles.consentCompleteMsg)}>{Helper.getString('consentCompleteMsg2')}</p>
          </div>
        }
        <p className={css(CommonStyles.stepperTitleContent)}>Survey Choice</p>
        <p className={css(CommonStyles.stepperSubTitleContent)}>{Helper.getString('customizeSectionSubtitle')}</p>

        {this.state.mandatory &&
          this.state.mandatory.length > 0 &&
          <div className={css(Styles.tileOuterContainer)}>

            <CatHeader catType={dataItem.surveyCatInfo.essential.catType} />

            <Grid container spacing={3} >
              {this.state.mandatory &&
                this.state.mandatory.map(item => {
                  return (
                    <Grid item xs={12} sm={6} key={item.id}>
                      <div
                        className={css(Styles.tileContainer, Styles.tileContainerMandatory)}
                        onClick={(e) => this.onMandatoryTileClicked()}>
                        <div className={css(Styles.tileImgContainer)}>
                          <img
                            src={item.image}
                            className={css(Styles.tileImg)}
                          />
                        </div>
                        <p className={css(Styles.tileTitle)}>{item.title}</p>
                        <div className={css(Styles.completedTile)}>
                          <div className={css(Styles.completedIconContainer)}>
                            <Icon className={css(Styles.completedIconContent)}>done</Icon>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  )
                })}
            </Grid>
          </div>
        }

        {this.state.optionals &&
          this.state.optionals.length > 0 &&
          <div className={css(Styles.tileOuterContainer)}>

            <CatHeader catType={dataItem.surveyCatInfo.optional.catType} />

            <Grid container spacing={3}>
              {this.state.optionals &&
                this.state.optionals.map(item => {
                  return (
                    <Grid item xs={12} sm={6} key={item.id}>
                      <div
                        className={css(Styles.tileContainer)}
                        onClick={(e) => this.onTileClicked(item)}>
                        <div className={css(Styles.tileImgContainer)}>
                          <img
                            src={item.image}
                            className={css(Styles.tileImg)}
                          />
                        </div>
                        <p className={css(Styles.tileTitle)}>{item.title}</p>
                        {this.state.selectedTileIds[item.id] &&
                          <div className={css(Styles.completedTile)}>
                            <div className={css(Styles.completedIconContainer)}>
                              <Icon className={css(Styles.completedIconContent)}>done</Icon>
                            </div>
                          </div>
                        }
                      </div>
                    </Grid>
                  )
                })}
            </Grid>
          </div>
        }

        {this.state.baselines &&
          this.state.baselines.length > 0 &&
          <div className={css(Styles.tileOuterContainer)}>

            <CatHeader catType={dataItem.surveyCatInfo.recommended.catType} />

            <Grid container spacing={3} >
              {this.state.baselines &&
                this.state.baselines.map(item => {
                  return (
                    <Grid item xs={12} sm={6} key={item.id}>
                      <div
                        className={css(Styles.tileContainer)}
                        onClick={(e) => this.onTileClicked(item)}>
                        <div className={css(Styles.tileImgContainer)}>
                          <img
                            src={item.image}
                            className={css(Styles.tileImg)}
                          />
                        </div>
                        <p className={css(Styles.tileTitle)}>{item.title}</p>
                        {this.state.selectedTileIds[item.id] &&
                          <div className={css(Styles.completedTile)}>
                            <div className={css(Styles.completedIconContainer)}>
                              <Icon className={css(Styles.completedIconContent)}>done</Icon>
                            </div>
                          </div>
                        }
                      </div>
                    </Grid>
                  )
                })}
            </Grid>
          </div>
        }
      </div>
    )
  }

  isValidAgeLimit = () => {
    if (this.state.baselines.length === 0 &&
      this.state.optionals.length === 0 &&
      this.state.mandatory.length === 0) {
      return false
    }

    if (!this.props.responseByQuestionId ||
      !this.props.responseByQuestionId.preferedQSections ||
      this.props.responseByQuestionId.preferedQSections.length === 0) {
      return true
    }

    if (this.props.inProcess || this.props.errMsg) {
      return true
    }
    const age = Helper.calculateAge(this.props.responseByQuestionId.dob)

    if (age >= AppConfig.AGE_UPPER_LIMIT) {
      return true
    }

    return false
  }

  closeMandatoryMsgDialog = (action) => {
    this.setState({
      mandatoryMsgDialog: false
    })
  }

  onMandatoryTileClicked = () => {
    this.setState({
      mandatoryMsgDialog: true
    })
  }

  closeMsgDialog = (action) => {
    this.setState({
      showMsgDialog: false
    })
    if (!this.isValidAgeLimit()) {
      //TODO:do nothing
    } else if (action === 'OK') {
      this.onFinish()
    }
  }

  showMsgDialog = () => {
    const age = Helper.calculateAge(this.props.responseByQuestionId.dob)
    if (age < AppConfig.AGE_UPPER_LIMIT) {
      this.setState({
        showMsgDialog: true
      })
    } else {
      this.onFinish()
    }
  }

  readyView() {
    return (
      <div className={css(CommonStyles.stepperInnerContainer)}>
        {this.showSurveys()}

        {this.isValidAgeLimit() &&
          <div>
            <ButtonComponent
              label='CONTINUE'
              inProcess={this.props.inProcess}
              onSelect={() => this.showMsgDialog()}
            />
          </div>
        }

        {/*TODO: Customize warning dialog content*/}
        <MsgDialog
          showDialog={this.state.showMsgDialog}
          closeDialog={this.closeMsgDialog}
          title={'Please Note!'}
          leftBtnTitle={this.isValidAgeLimit() ? 'CANCEL' : null}
          rightBtnTitle={this.isValidAgeLimit() ? 'CONTINUE' : 'OK'}
          descr={Helper.getString('ageLimitSurveyChoiceWarning')}
        />

        <MsgDialog
          showDialog={this.state.mandatoryMsgDialog}
          closeDialog={this.closeMandatoryMsgDialog}
          title={'Please Note!'}
          rightBtnTitle={'OK'}
          descr={Helper.getString('mandatorySurveyNote')}
        />

      </div>
    );
  }
}

const tileWidth = 328;
const tileHeight = 153;
const Styles = StyleSheet.create({
  tileOuterContainer: {
    maxWidth: 700,
    width: '90%',
    marginTop: 20,
    marginBottom: 20,
    border: '1px solid' + AppTheme.primaryColor,
    padding: 50,
    paddingTop: 20,
    borderRadius: 50,
    '@media (max-width: 767px)': {
      marginTop: 20,
      padding: 20,
      paddingTop: 15,
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      marginTop: 20,
    },
  },
  tileContent: {
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  tileInnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 767px)': {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  },
  tileContainer: {
    cursor: 'pointer',
    overflow: 'hidden',
    backgroundColor: AppTheme.tertiaryBg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: tileHeight,
    borderRadius: 12,
    boxShadow: '2px 2px 3px #B5B5B5',
    position: 'relative',
  },
  tileContainerMandatory: {
    cursor: 'unset'
  },
  tileImgContainer: {
    flex: .5,
    maxWidth: '100%',
    display: 'flex',
    height: '100%',
    alignItems: 'center'
  },

  tileImg: {
    maxWidth: '90%',
    maxHeight: '90%',
    borderRadius: 12
  },
  tileTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    flex: .5,
    color: AppTheme.textColor,
    fontSize: AppTheme.fontSize,
    margin: '0px 15px',
    textTransform: 'uppercase',
    '@media (max-width: 767px)': {
      fontSize: 18,
    }
  },
  completedTile: {
    width: '97%',
    height: tileHeight - 10,
    position: 'absolute',
    backgroundColor: '#9A9DE479',
    zIndex: 1,
    opacity: 1,
    borderRadius: 12,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    '@media (max-width: 767px)': {
      width: '96%',
      height: tileHeight - 15,
    },
  },
  completedIconContent: {
    fontSize: 50,
    fontWeight: 'bolder',
    color: AppTheme.secondaryBg
  },
  message: {
    fontSize: 25,
    color: AppTheme.textColor,
    textAlign: 'center',
    '@media (max-width: 767px)': {
      fontSize: 18
    }
  },
  consentCompleteMsg: {
    color: AppTheme.secondaryColor,
    marginBottom: 10,
    fontSize: 35,
    '@media (max-width: 767px)': {
      fontSize: 20
    }
  },
  consentCompleteMsgContainer: {
    marginBottom: 40
  }
})


// WEBPACK FOOTER //
// ./src/components/Customize.js